import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import purify from 'dompurify';
import { Grid, Text } from 'elements';
import { RootState } from 'modules';
import Reply from 'components/base/reply/';
import { showConfirm } from 'components/modal/showConfirm';
import {
  getLibraryItem,
  getLibraryReply,
  delLibraryItem,
  createLibraryReply,
  updateLibraryReply,
  likeLibraryReply,
  recommendLibary,
  delLibraryReply,
} from 'libs/api/case';
import { TLibrary } from 'modules/case/types';
import { CWindowWidth } from 'constants/base.const';
import { EmployedTypes, RegionTypes } from 'enums/base.enum';
import { Button, Spin } from 'antd';
import { Colors } from 'GlobalStyles';
import MainBackImage from 'assets/images/banners/4.webp';

const LibraryDetail = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const { id }: { id: string } = useParams();
  const history = useHistory();
  const [library, setLibrary] = useState<TLibrary>();

  const getLibrary = async () => {
    const { success, data, error } = await getLibraryItem(id);
    if (success) {
      let finded = EmployedTypes.find((t) => t.value === data.hired_type);
      if (finded) data.hired_type_text = finded.text;
      finded = RegionTypes.find((t) => t.value === data.location);
      if (finded) data.location_text = finded.text;
      setLibrary(data);
    }
    // else {
    //   if (error.response.data.error_code === '-403005') {
    //     showAlert(() => history.go(-1), '', '작성한 게시글 수가 부족하여 열람하실 수 없습니다.');
    //   }
    // }
  };

  const delLibrary = () => {
    showConfirm(
      async () => {
        const { success } = await delLibraryItem(id);
        if (success) history.push('/case/library/');
      },
      '해설 삭제',
      '해설을 삭제하시겠습니까?',
    );
  };

  const recommend = async (isGood = false) => {
    const { success } = await recommendLibary(id, isGood);
    if (success) getLibrary();
  };

  useEffect(() => {
    getLibrary();
  }, []);

  return (
    <>
      <Grid image={MainBackImage} height='400px' md={{ height: '100px' }}>
        <Grid height='100%' backgroundColor={`${Colors.black}33`} justify='center'>
          <Grid width={`${CWindowWidth}px`} padding='0 7%' align='center'>
            <Grid>
              <Text color={Colors.white} size='4rem' bold md={{ size: '2rem' }}>
                Case 기출 라이브러리
              </Text>
            </Grid>
            <Grid marginTop='5px'>
              <Text color={Colors.white} size='1.1rem' md={{ size: '0.9rem' }}>
                Case 인터뷰 실제 기출문제 게시판입니다.
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid justify='center'>
        <Grid width={`${CWindowWidth}px`} padding='38px 20px 150px 20px'>
          {!library ? (
            <Grid justify='center' align='center' height='100px'>
              <Spin spinning />
            </Grid>
          ) : (
            <>
              <Grid isNoWrap justify='space-between' align='flex-end'>
                <Grid isInline>
                  <Grid gap='10px' align='center'>
                    <Text bold>작성일자</Text>
                    <Text>{library.created_at || '-'}</Text>
                  </Grid>
                  <Grid gap='15px' align='center' marginTop='8px'>
                    <Grid isInline gap='10px' align='center'>
                      <Text bold>회사</Text>
                      <Text>{library.company?.company_name || '-'}</Text>
                    </Grid>
                    <Grid isInline gap='10px' align='center'>
                      <Text bold>지역</Text>
                      <Text>{library.location_text || '-'}</Text>
                    </Grid>
                    <Grid isInline gap='10px' align='center'>
                      <Text bold>구분</Text>
                      <Text>{library.hired_type_text || '-'}</Text>
                    </Grid>
                    <Grid isInline gap='10px' align='center'>
                      <Text bold>기출 시기</Text>
                      <Text>{library.interview_date || '-'}</Text>
                    </Grid>
                  </Grid>
                  <Grid gap='20px' align='center' marginTop='8px'>
                    <Grid isInline gap='10px' align='center'>
                      <Text>조회수</Text>
                      <Text>{library.hit_count ?? '-'}</Text>
                    </Grid>
                    <Grid isInline gap='10px' align='center'>
                      <Text>추천</Text>
                      <Text>{library.is_good ?? '-'}</Text>
                    </Grid>
                    <Grid isInline gap='8px' align='center'>
                      <Text>이 case</Text>
                      <Button
                        className={`small secondary ${library.is_user_satisfaction ? '' : 'outline'}`}
                        onClick={() => recommend(true)}
                      >
                        추천
                      </Button>
                      <Button
                        className={`small danger ${!library.is_user_satisfaction ? '' : 'outline'}`}
                        onClick={() => recommend(false)}
                      >
                        비추천
                      </Button>
                      <Text>하기</Text>
                    </Grid>
                  </Grid>
                </Grid>
                <Button type='primary' onClick={() => history.go(-1)}>
                  목록
                </Button>
              </Grid>
              <Grid
                border={`1px solid ${Colors.grey5}`}
                minHeight='300px'
                align='flex-start'
                marginTop='35px'
              >
                <Grid padding='14px 20px' style={{ borderBottom: `1px solid ${Colors.grey5}` }}>
                  <Text>{library.title || '-'}</Text>
                </Grid>
                <Grid padding='14px 20px'>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: purify.sanitize(library.body || '-'),
                    }}
                  />
                </Grid>
              </Grid>
              {!!currentUser && currentUser.id === library.user && (
                <Grid marginTop='20px' justify='flex-end' align='center' gap='20px'>
                  <Button type='primary' onClick={delLibrary}>
                    삭제
                  </Button>
                  <Button type='primary' onClick={() => history.push(`/case/library/write?id=${id}`)}>
                    수정
                  </Button>
                </Grid>
              )}
            </>
          )}

          <Grid marginTop='50px' style={{ borderTop: `1px solid ${Colors.grey1}` }} />

          <Grid marginTop='50px'>
            <Reply
              page_type='library'
              id={Number(id)}
              getReply={getLibraryReply}
              onSave={createLibraryReply}
              onEdit={updateLibraryReply}
              like={likeLibraryReply}
              del={delLibraryReply}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default LibraryDetail;
